import {openPopupWindow} from "../../../../../../../emitters/popup";
import Popup from "../../../../../../dumb/Popup/B";
import WrapperWithLoading from "../../../../../../dumb/WrapperWithLoading/B";
import ButtonRed from "../../../../../../dumb/Button/Red";
import {apiTerminalsRemove} from "../../../../../../../api/merchant/terminals";
import filter from "mn-utils/filter";
import ButtonDecline from "../../../../../../dumb/Button/Decline";
import React from "react";

export default (data, update) => openPopupWindow((setPopupState, popup) => {
  const id = data.id;

  const {
    close,
  } = popup;
  return (stateOfPopup) => {
    return (
      <Popup caption="Are you sure you want to delete this terminal?">
        <WrapperWithLoading
          loading={stateOfPopup.loading}
        >
          <div className="mt40 cfx mh-10 (lt|ph10|pt20)>1">
            <div>
              <ButtonRed
                onClick={() => {
                  setPopupState({
                    loading: true,
                  });
                  apiTerminalsRemove({
                    id,
                  }).finally((error) => {
                    setPopupState({
                      loading: false,
                    });
                    if (error) {
                      return;
                    }
                    update();
                    // openPopupInfo(['Terminal has been deleted']);
                    close();
                  });
                }}
              >Delete</ButtonRed>
            </div>
            <div>
              <ButtonDecline
                onClick={close}
              >Cancel</ButtonDecline>
            </div>
          </div>
        </WrapperWithLoading>
      </Popup>
    );
  };
});
